import { defineMessages } from 'react-intl';

export default defineMessages({
  courses_seller: {
    id: 'Most sold courses',
    defaultMessage: '{counter, plural, one {Most sold course} other {Most sold courses}}'
  },
  courses_random: {
    id: 'Most viewed courses',
    defaultMessage: '{counter, plural, one {Most viewed course} other {Most viewed courses}}'
  },
  courses_featured: {
    id: 'Courses featured',
    defaultMessage: '{counter, plural, one {Featured course} other {Featured courses}}'
  },
  services_catalog: {
    id: 'Services catalog',
    defaultMessage: 'Services catalog',
  },
  services_featured: {
    id: 'Services featured',
    defaultMessage: '{counter, plural, one {Featured service} other {Featured services}}'
  },
  services_newlyreserved: {
    id: 'Services recently reserved',
    defaultMessage: '{counter, plural, one {Recently reserved service} other {Recently reserved services}}'
  },
  services_recent: {
    id: 'Recent services',
    defaultMessage: '{counter, plural, one {Recent service} other {Recent services}}'
  },
  professionals_catalog: {
    id: 'Professionals catalog',
    defaultMessage: 'Professionals catalog',
  },
  professionals_featured: {
    id: 'Professionals featured',
    defaultMessage: '{counter, plural, one {Featured professional} other {Featured professionals}}'
  },
  professionals_recent: {
    id: 'Recent Professionals',
    defaultMessage: '{counter, plural, one {Recent professional} other {Recent professionals}}'
  },
  professionals_best: {
    id: 'Professionals most valued',
    defaultMessage: '{counter, plural, one {Most-valued professional} other {Most-valued professionals}}'
  },
});
